import { enforceDoubles } from "core/utils/general";
/**
 * Formats a given date in the form of 01/01/2020
 * seperator can be customized
 */
export function getDateNotation(dateString, separator) {
    if (separator === void 0) { separator = "/"; }
    var d = new Date(dateString);
    return "".concat(enforceDoubles(d.getDate())).concat(separator).concat(enforceDoubles(d.getMonth() + 1)).concat(separator).concat(d.getFullYear());
}
